import { render, staticRenderFns } from "./HorseRaceLamp.vue?vue&type=template&id=88674c60&scoped=true"
import script from "./HorseRaceLamp.vue?vue&type=script&lang=js"
export * from "./HorseRaceLamp.vue?vue&type=script&lang=js"
import style0 from "./HorseRaceLamp.vue?vue&type=style&index=0&id=88674c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88674c60",
  null
  
)

export default component.exports